//Accessible Accordions
//https://github.com/scottaohara/accessible_modal_window

import AOS from "aos";

AOS.init({
  duration: 500,
  offset: 100,
  easing: "ease-out-quad",
  once: true
});
